import React, {useState, useEffect} from 'react';
import {
    MemoryRouter as Router,
    Switch,
    Route,
    NavLink as RouterNavLink
} from "react-router-dom";
import {Container, Nav, NavItem, NavLink} from "reactstrap";
import "./assets/scss/app.scss";
import Auth from "./pages/Auth";
import {getToken} from "./services/auth";
import api from "./services/api";
import {useDispatch} from "react-redux";
import {receiveUser} from "./redux/auth/actions";
import PurchaseHistory from "./pages/PurchaseHistory";
import Profile from "./pages/Profile";
import ProfileEdit from "./pages/ProfileEdit";
import Header from "./components/Header";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {fetchSchoolSuccess} from "./redux/school/actions";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import qs from 'query-string';
import EnrollmentV2 from "./pages/EnrollmentV2";
import ReactTooltip from "react-tooltip";

function App() {
    const [loading, setLoading] = useState(true);
    const token = getToken();
    const passwordResetEmail = qs.parse(window.location.search)['password-reset-email'];
    const passwordResetToken = qs.parse(window.location.search)['password-reset-token'];
    const dispatch = useDispatch();

    useEffect(() => {
        (async function () {
            const school = await api.fetchSchool().then(response => response.data.data);
            dispatch(fetchSchoolSuccess(school));

            if (token) {
                const response = await api.fetchMe();
                dispatch(receiveUser(response.data.data));
            }

            setLoading(false);
        })();
    }, []);


    return (
        <React.Fragment>
            {!loading &&
            <Container>
                <Router>
                    <Switch>
                        <Route path="/" exact>
                            <Auth passwordResetToken={passwordResetToken}
                                  passwordResetEmail={passwordResetEmail}
                            />
                        </Route>

                        <Route path="/forget-password" exact>
                            <ForgetPassword/>
                        </Route>

                        <Route path="/reset-password" exact>
                            <ResetPassword/>
                        </Route>

                        <Route>
                            <Header/>

                            <div className="row">
                                <div className="col-sm-3">
                                    <Nav vertical id="sidebar">
                                        <NavItem>
                                            <NavLink to="/enrollment" activeClassName="active" tag={RouterNavLink}>
                                                Enrollment
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink to="/profile" activeClassName="active" tag={RouterNavLink}>
                                                Edit Profile
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink to="/purchase-history" activeClassName="active" tag={RouterNavLink}>
                                                Purchase History
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                                <div className="col-sm-9">
                                    <Switch>
                                        <Route path="/enrollment" exact>
                                            <EnrollmentV2/>
                                        </Route>
                                        <Route path="/purchase-history" exact>
                                            <PurchaseHistory/>
                                        </Route>
                                        <Route path="/profile" exact>
                                            <Profile/>
                                        </Route>
                                        <Route path="/profile/edit" exact>
                                            <ProfileEdit/>
                                        </Route>
                                    </Switch>
                                </div>
                            </div>
                        </Route>
                    </Switch>
                </Router>
            </Container>}
            <ToastContainer />
            <ReactTooltip className="custom-react-tooltip"/>
        </React.Fragment>
    );
}

export default App;
